import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
// import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
//Locales
// import en from "../../locales/en/translation.json";
// import sr from "../../locales/sr/translation.json";

function createData(
  aqi,
  airPollutionLevel,
  healthImplications,
  cautionaryStatement
) {
  return { aqi, airPollutionLevel, healthImplications, cautionaryStatement };
}

const rows = [
  createData(
    "0-50",
    "Good",
    "Air quality is considered satisfactory, and air pollution poses little or no risk.",
    "None"
  ),
  createData(
    "51-100",
    "Moderate",
    "Air quality is acceptable; however, for some pollutants there may be a moderate health concern for a very small number of people who are unusually sensitive to air pollution.",
    "Active children and adults, and people with respiratory disease, such as asthma, should limit prolonged outdoor exertion."
  ),
  createData(
    "101-150",
    "Unhealthy for Sensitive Groups",
    "Members of sensitive groups may experience health effects. The general public is not likely to be affected.",
    "Active children and adults, and people with respiratory disease, such as asthma, should limit prolonged outdoor exertion."
  ),
  createData(
    "151-200",
    "Unhealthy",
    "Everyone may begin to experience health effects; members of sensitive groups may experience more serious health effects",
    "Active children and adults, and people with respiratory disease, such as asthma, should avoid prolonged outdoor exertion; everyone else, especially children, should limit prolonged outdoor exertion"
  ),
  createData(
    "201-300",
    "Very Unhealthy",
    "Health warnings of emergency conditions. The entire population is more likely to be affected.",
    "Active children and adults, and people with respiratory disease, such as asthma, should avoid all outdoor exertion; everyone else, especially children, should limit outdoor exertion."
  ),
  createData(
    "300+",
    "Hazardous",
    "Health alert: everyone may experience more serious health effects.",
    "Everyone should avoid all outdoor exertion."
  ),
];

const rows1 = [
  createData(
    "0-50",
    "Dobro",
    "Kvalitet vazduha se smatra zadovoljavajućim, a zagađenost vazduha predstavlja mali ili nikakav rizik.",
    "Nijedan"
  ),
  createData(
    "51-100",
    "Umereno",
    "Kvalitet vazduha je prihvatljiv; Međutim, za nku polulaciju može postojati umerena zabrinutost za zdravlje veoma malog broja ljudi koji su koji su osetljivi na zagađenje vazduha.",
    "Aktivna deca i odrasli, kao i ljudi sa respiratornim oboljenjima, kao što je asma, trebalo bi da ograniče boravak na otvorenom."
  ),
  createData(
    "101-150",
    "Nezdravo za osetljive grupe",
    "Populacija osetljivih grupa mogu imati zdravstvene posledice. Najverovatnije neće uticati na širu javnost.",
    "Aktivna deca i odrasli, kao i ljudi sa respiratornim oboljenjima, kao što je asma, trebalo bi da ograniče boravak na otvorenom."
  ),
  createData(
    "151-200",
    "Nezdravo",
    "Svako može da ima zdravstvene posledice; Pripadnici osetljivih grupa mogu imati ozbiljnije zdrvstvene posledice.",
    "Aktivna deca i odrasli, kao i ljudi sa respiratornim oboljenjima, kao što je asma, trebalo bi da ograniče boravak na otvorenom; Svi ostali, posebno deca, treba da ograniče fizičku aktivnost na otvorenom."
  ),
  createData(
    "201-300",
    "Veoma nezdravo",
    "Zdravstveno upozorenje o vanrednoj situaciji. Velika je verovatnoća da će cela populacija biti pogođena.",
    "Aktivna deca i odrasli, kao i ljudi sa respiratornim oboljenjima, kao što je asma, trebalo bi da ograniče boravak na otvorenom; Svi ostali, posebno deca, treba da ograniče fizičku aktivnost na otvorenom."
  ),
  createData(
    "300+",
    "Opasno",
    "Zdravstveno upozorenje: svako može imati ozbiljnije zdravstvene posledice.",
    "Svako treba da izbegava boravak i fizičke aktivnosti na otvorenomi."
  ),
];

function TableAirQualityLevels() {
  let i = 0;
  const theme = useTheme();
  const { t } = useTranslation();
  const language = useSelector((state) => state.i18n.language);
  // useEffect(() => {
  //   translateDropdownButtonValues(language);
  // }, [language])

  // Prevodjenje ponudjenih vrednosti
  // const translateDropdownButtonValues = (langCode) => {
  //   let file;
  //     switch (langCode) {
  //         case 'en':
  //             file = en;
  //             break;
  //         case 'sr':
  //             file = sr;
  //             break;
  //         default:
  //             return;
  //     };
  // }

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead sx={{ backgroundColor: theme.palette.secondary.main }}>
          <TableRow sx={{ backgroundColor: theme.palette.secondary.main }}>
            <TableCell>{t("tableairqualitylevels.aqi")}</TableCell>
            <TableCell>{t("tableairqualitylevels.air")}</TableCell>
            <TableCell>{t("tableairqualitylevels.health")}</TableCell>
            <TableCell>{t("tableairqualitylevels.cautionary")}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {language === "en" &&
            rows.map((row) => (
              <TableRow key={row.aqi}>
                <TableCell
                  component="th"
                  /*sx={{ backgroundColor: bc[i] }}*/
                >
                  {row.aqi}
                </TableCell>
                <TableCell /*sx={{ backgroundColor: bc[i] }}*/>
                  {row.airPollutionLevel}
                </TableCell>
                <TableCell /*sx={{ backgroundColor: bc[i] }}*/>
                  {row.healthImplications}
                </TableCell>
                <TableCell /*sx={{ backgroundColor: bc[i++] }}*/>
                  {row.cautionaryStatement}
                </TableCell>
              </TableRow>
            ))}
          {language === "sr" &&
            rows1.map((row) => (
              <TableRow key={row.aqi}>
                <TableCell component="th" /*sx={{ backgroundColor: bc[i] }}*/>
                  {row.aqi}
                </TableCell>
                <TableCell /*sx={{ backgroundColor: bc[i] }}*/>
                  {row.airPollutionLevel}
                </TableCell>
                <TableCell /*sx={{ backgroundColor: bc[i] }}*/>
                  {row.healthImplications}
                </TableCell>
                <TableCell /*sx={{ backgroundColor: bc[i++] }}*/>
                  {row.cautionaryStatement}
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default TableAirQualityLevels;

//const bc = ["#009966", "#ffde33", "#ff9933", "#cc0033", "#660099", "#7e0023"];
/*
style="background-color:#009966;"
style="background-color:#ffde33"
style="background-color:#ff9933;"
style="background-color:#cc0033;"
style="background-color:#660099;"
style="background-color:#7e0023;"
*/
